import { V as a, T as o, P as s, O as r, d as t, L as E, C as O, c as l, A as n } from "../../../../brands-CoixlYYY.js";
import e from "../current/colors.mjs";
const A = {
  blue200: "#9ADBE8",
  blue750: "#1C2640",
  green650: "#008140",
  grey500: "#6E6E6B",
  grey50: "#F9F9F9",
  pink100: "#F7CED7",
  pink300: "#FF808B",
  purple750: "#2E1A47",
  orange500: "#FA5600",
  red550: "#E40046",
  red650: "#CC2427",
  teal600: "#007B90"
}, c = {
  [n]: e.agent,
  [l]: e.ASOS,
  [O]: e.capitalOne,
  [E]: e.littlewoods,
  [t]: e.luma,
  [r]: e.ocean,
  [s]: A,
  [o]: e.thinkMoney,
  [a]: e.very
};
export {
  c as default
};
